import React, { InputHTMLAttributes, useContext } from 'react';
import { useDispatch } from 'react-redux';
import Input from '~/components/Input';
import Label from '~/components/Label';
import { FuelContext } from '~/providers/FuelProvider';
import { setSelectedSweetener } from '~/redux/actions/products';
import { Option } from '~/types/products';
import MobileFiltersStyled from './MobileFiltersStyled';
import ComparePlans from '~/components/Icons/outline/ComparePlans';
import PlainButton from '~/components/PlainButton';

interface Props {
  productFilters?: {
    addPhoneState: boolean;
    options: Option[];
    setOptions: (options: Option[]) => void;
    sweetener: Option;
    voiceAvailable: boolean;
    handleAddHomePhone: (event: InputHTMLAttributes<HTMLInputElement>) => void;
    setSweetener: (selected: Option) => void;
  };
  options?: {
    phone: string;
    rewards: string;
  };
  setOpenModal?: () => void;
  comparisonToolEnabled: boolean;
}

const MobileFilters: React.FC<Props> = ({ productFilters, options, setOpenModal, comparisonToolEnabled }) => {
  const { trackEvent } = useContext(FuelContext);
  const dispatch = useDispatch();

  const handleClaimRewards = (event) => {
    const checked = event.target.checked;
    const selected = { label: checked ? 'Claim Rewards' : 'Skip Rewards', value: checked ? 'visa' : 'skip' };
    dispatch(setSelectedSweetener(selected));
    productFilters?.setSweetener(selected);

    trackEvent({
      action: 'elementClicked',
      data: {
        elementType: 'TAB',
        position: 'VRC',
        action: 'TOGGLE',
        text: selected?.value,
      },
    });
  };

  return (
    <MobileFiltersStyled>
      <div className="plan-packages__action-bar">
        <div className="filter-container">
          {productFilters.voiceAvailable && (
            <div className="add-ons">
              <h2 className="add-ons-title">Select your add-ons</h2>
              <div className="product-filters__phone">
                <Label>
                  <Input
                    type="checkbox"
                    onChange={(event) => handleClaimRewards(event)}
                    checked={productFilters?.sweetener?.value === 'visa'}
                  />{' '}
                  {options?.rewards || 'Claim Rewards'}
                </Label>
              </div>
            </div>
          )}
        </div>
        {comparisonToolEnabled && (
          <PlainButton className="compare-plans-button" onClick={setOpenModal} icon={<ComparePlans />}>
            Compare Plans
          </PlainButton>
        )}
      </div>
    </MobileFiltersStyled>
  );
};

MobileFilters.displayName = 'MobileFilters';

export default MobileFilters;
